import { storage } from '@/utils';
import http from './http';

// 地板价模版导入
export const importPriceFloorTemplate = (data) => {
  return http({
    method: 'POST',
    url: `/floor-price-config/import`,
    data,
  });
};

// 地板价模版下载
export const downloadPriceFloorTemplate = (data) => {
  return http({
    method: 'POST',
    url: `/floor-price-config/export`,
    responseType: 'blob',
    data,
  });
};

export const fetchDyzlProductLogPage = (data?) => {
  return http({
    method: 'POST',
    url: `/product-logs/dyzl/log`,
    data,
  });
};
export const fetchXczlProductLogPage = (data?) => {
  return http({
    method: 'POST',
    url: `/product-logs/xczl/log`,
    data,
  });
};
export const fetchMtzlProductLogPage = (data?) => {
  return http({
    method: 'POST',
    url: `/product-logs/mtzl/log`,
    data,
  });
};

// 中央预订产品管理
export const fetchCRSProductLogPage = (data?) => {
  return http({
    method: 'POST',
    url: `/product-logs/crs/log`,
    data,
  });
};

// 直连房量排查渠道明细
export const fetchInventoryCheckChannelDetail = (data?) => {
  return http({
    method: 'POST',
    url: `/room-quantity/troubleshoot/channel`,
    data,
  });
};

// 直连房量排查
export const fetchInventoryCheck = (params?) => {
  return http({
    url: `/room-quantity/troubleshoot`,
    params,
  });
};
// 促销计算接口
export const fetchPromotionCalculate = (data) => {
  return http({
    method: 'POST',
    url: `/price/promotion/calculate`,
    data,
  });
};
// 佣金率
export const fetchChannelCommission = (params) => {
  return http({
    url: `/hotel-channel-config/channel-commission`,
    params,
  });
};
// 促销活动列表
export const fetchPromotionActivities = (data) => {
  return http({
    method: 'POST',
    url: `/ota/promotion/date/list`,
    data,
  });
};

// 当前直连绑定的房型
export const fetchDirectRoomTypes = (params) => {
  return http({
    url: `/ota/promotion/direct/bind/room-types?priceChannel=${params.priceChannel}`,
  });
};

// 促销直连渠道
export const fetchDirectChannels = () => {
  return http({
    url: `/channels/directs`,
  });
};
// 促销日志
export const fetchPromotionLogPgae = (data?: any) => {
  return http({
    method: 'POST',
    url: `/hotel/hotel-log-page-query`,
    data,
  });
};
// 修改集团统控促销状态
export const fetchUpdateHotelPromotionStatus = (data?: any) => {
  return http({
    method: 'POST',
    url: `/hotel/update-promotion-status`,
    data,
  });
};
// 集团促销状态列表
export const fetchHotelPromotionPage = (data?: any) => {
  return http({
    method: 'POST',
    url: `/hotel/page-query`,
    data,
  });
};
// 门店详情配置
export const fetchHotelConfig = (params?: any) => {
  return http({
    url: `/discount-config/detail`,
    params,
  });
};

// crs渠道状态
export const fetchCrsChannelStatus = (params?: any) => {
  return http({
    url: `/hotel-channel-config/crs/channel-status`,
    params,
  });
};

// 自动接单更新
export const fetchCrsAutoReserve = (data?: any) => {
  return http({
    method: 'PUT',
    url: `/hotel-channel-config/crs/auto-reserve`,
    data,
  });
};

// 获取房量库存配置信息
export const fetchGetRoomInventory = (params?: any) => {
  return http({
    url: `/room-inventory/v2/get`,
    params,
  });
};

// 保存房量配置
export const fetchUpdateRoomInventory = (data) => {
  return http({
    method: 'PUT',
    url: `/room-inventory`,
    data,
  });
};

// 更新期望上架房量
export const fetchUpdateCrsRoomQuantity = (data) => {
  return http({
    method: 'PUT',
    url: `/rooms/avail`,
    data,
  });
};

// 查询CRS房量
export const fetchCrsRoomQuantity = (data) => {
  return http({
    method: 'POST',
    url: `/room-quantity/crs/search`,
    data,
  });
};

// 门店房型配置列表
export const fetchGetRoomTypeConfig = (params) => {
  return http({
    url: `/room-type-config/list`,
    params,
  });
};

// 直连不可订房量修改
export const fetchUpdateRoomTypeConfig = (data) => {
  return http({
    method: 'PUT',
    url: `/room-type-config`,
    data,
  });
};

// 美团直连查询同步信息
export const fetchGetChannelSync = (params: { commonCode: string; module: string }) => {
  return http({
    method: 'GET',
    url: `/channel-sync/events`,
    params,
  });
};

// 推送模块数据
export const fetchPushChannelSync = (data) => {
  return http({
    method: 'PUT',
    url: `/channel-sync/push`,
    data,
  });
};

// 钟点房期望上架房量
export const fetchSheftExpectedQuantity = (data) => {
  return http({
    method: 'POST',
    url: `/room-inventory/time-rent/shelf`,
    data,
  });
};

export const fetchGetHotelChannelList = (params?) => {
  return http({
    url: `/hotel-channel-config/list/by/commonCode`,
    params,
  });
};

// 动态获取门店渠道配置列表
export const fetchGetHotelChannelConfig = (data) => {
  return http({
    method: 'POST',
    url: `/hotel-channel-config/list/dynamic`,
    data: {
      commonCode: storage.get('commonCode'),
      ...data,
    },
  });
};

// 上/下架
export const fetchSwitchShelf = (data) => {
  return http({
    method: 'PUT',
    url: `/hotel-channel-config/shelf/status/switch`,
    data,
  });
};

// 查询详情
export const fetchChannelDetail = (params) => {
  return http({
    url: `/hotel-channel-config/detail`,
    params,
  });
};

// 修改门店渠道配置
export const fetchUpdateChannelDetail = (data) => {
  return http({
    method: 'PUT',
    url: `/hotel-channel-config`,
    data: {
      commonCode: storage.get('commonCode'),
      ...data,
    },
  });
};

// 创建门店渠道配置
export const fetchCreateChannelDetail = (data) => {
  return http({
    method: 'POST',
    url: `/hotel-channel-config`,
    data: {
      commonCode: storage.get('commonCode'),
      ...data,
    },
  });
};

// 查询渠道房型列表
export const fetchChannelRoomTypeList = (params) => {
  return http({
    url: '/room-quantity/channel/room-type/list',
    params,
  });
};

// 批量修改渠道房量
export const batchModifyRoomQuantity = (data) => {
  return http({
    method: 'PUT',
    url: '/rooms/avail/batch',
    data,
  });
};

// 获取逻辑房型列表
export const fetchLogicRoomTypeList = () => {
  return http({
    url: '/room-type/logic-room-type',
  });
};

// 保存共享库存配置
export const saveRoomTypeShareConfig = (data) => {
  return http({
    method: 'POST',
    url: '/room-type/logic-room-type',
    data,
  });
};

// 创建CRS产品
export const createCRSApi = (data) => {
  return http({
    method: 'POST',
    url: '/ota/product/create/crs',
    data,
  });
};

// 修改中央预订产品
export const updateCRSApi = (data) => {
  return http({
    method: 'PUT',
    url: `/ota/product/update/crs`,
    data,
  });
};

// 删除美团直连产品价格计划
export const fetchDeleteMtzlProduct = (params) => {
  return http({
    method: 'DELETE',
    url: '/ota/product/delete/rp',
    params,
  });
};

// 移除钟点房
export const fetchDeleteChannelRoomType = (data) => {
  return http({
    url: `/hotel-channel-config/${data.id}`,
    method: 'DELETE',
  });
};

// 创建钟点房
export const fetchCreateChannelRoomType = (data) => {
  return http({
    url: '/hotel-channel-config',
    method: 'POST',
    data,
  });
};

// 自助促销活动列表
export const crsPromotionList = () => {
  return http({
    method: 'GET',
    url: `/crs/promotion/queryList`,
    params: { commonCode: storage.get('commonCode') },
  });
};

// 已报名促销
export const crsPromotionEnrolledList = (data) => {
  return http({
    method: 'POST',
    url: '/crs/promotion/enrolledList',
    data,
  });
};

// 操作日志
export const crsPromotionOperatorLog = (data) => {
  return http({
    method: 'GET',
    url: '/crs/promotion/operatorLog',
    params: data,
  });
};

// 报名促销
export const crsEnrollPromotion = (data) => {
  return http({
    method: 'POST',
    url: '/crs/promotion/enrollPromotion',
    data,
  });
};

// 编辑促销
export const crsUpdatePromotion = (data) => {
  return http({
    method: 'POST',
    url: '/crs/promotion/save',
    data,
  });
};

// 更改促销活动状态
export const crsPromotionUpdateState = (data) => {
  return http({
    method: 'POST',
    url: '/crs/promotion/updateState',
    data,
  });
};

// 促销详情
export const crsPromotionDetail = (params: { storePromotionRecordId: number }) => {
  return http({
    method: 'GET',
    url: `/crs/promotion/detail`,
    params,
  });
};

// 查询OTA产品列表
export const queryProductList = (data) => {
  return http({
    url: '/ota/product/list',
    method: 'POST',
    data,
  });
};

// 查询门店促销房型已参加促销活动
export const crsPromotionRoomList = (params: any) => {
  return http({
    method: 'GET',
    url: `/crs/promotion/queryRoomPromotionList`,
    params,
  });
};

// 促销活动规则详情
export const crsPromotionRuleDetail = (params: any) => {
  return http({
    method: 'GET',
    url: `/crs/promotion/promotionRuleDetail`,
    params,
  });
};

// 获取门店OTA名称
export const getOTANameInfo = (params) => {
  return http({
    method: 'GET',
    url: `/ota/shop/info/mounted`,
    params,
  });
};
// 改价申请列表(集团)
export const groupApplyUpdatePriceList = (data) => {
  return http({
    url: '/price-update-apply/list',
    method: 'POST',
    data,
  });
};

// 改价申请列表（门店）
export const applyUpdatePriceList = (data) => {
  return http({
    url: '/price-update-apply/shop-list',
    method: 'POST',
    data,
  });
};

// 门店房型配置列表
export const getOrganizationTree = (params) => {
  return http({
    method: 'GET',
    url: `/organization/org-tree`,
    params,
  });
};

// 更新门店OTA名称
export const updateOTANameInfo = (data) => {
  return http({
    method: 'POST',
    url: '/ota/shop/info/mounted/batch/update',
    data,
  });
};
// 查询通用房型列表
export const queryCommonRoomTypeList = () => {
  return http({
    url: '/common-room-type/list',
    method: 'POST',
  });
};

// 分页查询改价审批配置
export const queryPriceAuditConfigList = (data) => {
  return http({
    url: '/price/audit/setting/page',
    method: 'POST',
    data,
  });
};

// 分页查询改价审批配置日志
export const queryPriceAuditConfigLogList = (data) => {
  return http({
    url: '/price/audit/setting/log/page',
    method: 'POST',
    data,
  });
};

// 批量新增改价审批设置
export const batchCreatePriceAuditSetting = (data) => {
  return http({
    method: 'POST',
    url: '/price/audit/setting/batch',
    data,
  });
};

// 批量修改改价审批实则hi
export const batchUpdatePriceAuditSetting = (data) => {
  return http({
    method: 'PUT',
    url: '/price/audit/setting/batch',
    data,
  });
};

// 改价审批撤回
export const auditWithdrawPriceUpdateApply = (data) => {
  return http({
    method: 'PUT',
    url: `/price-update-apply/audit-withdraw`,
    data,
  });
};

// 改价审批通过
export const passPriceUpdateApply = (data) => {
  return http({
    method: 'PUT',
    url: `/price-update-apply/audit-pass`,
    data,
  });
};

// 改价审批退回
export const auditReturnPriceUpdateApply = (data) => {
  return http({
    method: 'PUT',
    url: `/price-update-apply/audit-return`,
    data,
  });
};

// 改价申请-详情
export const priceUpdateDetail = (params) => {
  return http({
    method: 'GET',
    url: `/price-update-apply/detail`,
    params,
  });
};

// 获取城市列表
let cacheRequestCityList: Promise<any>;
export const getCityList = () => {
  if (cacheRequestCityList) return cacheRequestCityList;
  cacheRequestCityList = http({
    method: 'GET',
    url: '/plans/city/list',
  }).then((res) => {
    if (!(res && res.data)) {
      cacheRequestCityList = null;
    }
    return res;
  });
  return cacheRequestCityList;
};

// 查询房型列表
export const fetchAllRoomTypeList = () => {
  return http({
    url: '/rooms/types/list',
    method: 'GET',
  });
};

// 组织架构树
export const getOrgTree = (params) => {
  return http({
    method: 'GET',
    url: `/plans/org-tree`,
    params,
  });
};

// ota最低价
export const getOTAMinPrice = (data) => {
  return http({
    method: 'POST',
    url: '/price/ota/min',
    data,
  });
};

// CRS建议价
export const getCRSAdvicePrice = (data) => {
  return http({
    method: 'POST',
    url: '/price/crs/calculate',
    data,
  });
};

// 通用促销-查询已报名促销活动列表
export const getOtaPromotionList = (data) => {
  return http({
    method: 'POST',
    url: '/ota/promotion/list',
    data,
  });
};

// 通用促销-校验促销活动
export const validOtaPromotion = (data) => {
  return http({
    method: 'POST',
    url: '/ota/promotion/valid',
    data,
  });
};

// 通用促销-退出促销活动
export const exitOtaPromotion = (params) => {
  return http({
    method: 'DELETE',
    url: '/ota/promotion',
    params,
  });
};

// 通用促销-查询促销活动详情
export const getPromotionDetail = (params) => {
  return http({
    method: 'GET',
    url: `/ota/promotion`,
    params,
  });
};

// 通用促销-查询促销日志
export const getPromotionLogs = (params) => {
  return http({
    method: 'GET',
    url: `/ota/promotion/logs`,
    params,
  });
};

// 集团统控-集团创建-修改校验
export const groupPromotionCheck = (data) => {
  return http({
    method: 'POST',
    url: '/shop/promotion/check',
    data,
  });
};

// 促销列表
export const getPromotionList = (data) => {
  return http({
    method: 'POST',
    url: '/ota/promotion/page',
    data,
  });
};

// 集团统控-批量作废促销规则
export const bathVoidPromotionRule = (data?: any) => {
  return http({
    method: 'PUT',
    url: `/shop/promotion/batch/cancel`,
    data,
  });
};

// 集团统控-集团新增促销活动
export const groupAddPromotionRule = (data) => {
  return http({
    method: 'POST',
    url: '/shop/promotion',
    data,
  });
};

// 创建报名活动
export const createOptionalPromotion = (data) => {
  return http({
    method: 'POST',
    url: '/ota/promotion/optional',
    data,
  });
};

// 集团统控-集团更新促销活动
export const groupUpdatePromotionRule = (data?: any) => {
  return http({
    method: 'PUT',
    url: `/shop/promotion`,
    data,
  });
};

// 编辑报名活动
export const updateOptionalPromotion = (data) => {
  return http({
    method: 'PUT',
    url: '/ota/promotion/optional',
    data,
  });
};

// 集团统控-批量作废促销规则
export const groupBatchCancelPromotionRule = (data?: any) => {
  return http({
    method: 'PUT',
    url: `/shop/promotion/batch/cancel`,
    data,
  });
};

// 集团统控-分页查询集团统控的门店
export const getIsGroupControlStores = (data) => {
  return http({
    method: 'POST',
    url: '/hotel/page-query',
    data,
  });
};

// 集团统控-查询促销规则详情
export const groupGetPromotionRuleDetail = (params) => {
  return http({
    method: 'GET',
    url: `/shop/promotion/detail`,
    params,
  });
};

// 集团统控-查询促销规则日志
export const groupPromotionRuleLog = (params) => {
  return http({
    method: 'POST',
    url: `/shop/promotion/edit-log/page`,
    data: params,
  });
};

// 集团统控-分页查询集团促销推送失败情况
export const groupPromotionPushFailLog = (params) => {
  return http({
    method: 'POST',
    url: `/shop/promotion/fail-log/page`,
    data: params,
  });
};

// 集团统控-重推失败的
export const groupPromotionRePush = (params) => {
  return http({
    method: 'GET',
    url: `/shop/promotion/rePush`,
    params,
  });
};

// 门店报名类活动列表
export const getShopPromotionList = () => {
  return http({
    method: 'GET',
    url: '/shop/promotion/list',
  });
};

// 门店报名类活动列表
export const getShopPromotionDetail = (params) => {
  return http({
    method: 'GET',
    url: '/shop/promotion/detail',
    params,
  });
};

// 获取门店基础信息
export const getHotelBasicInfo = () => {
  return http({
    method: 'GET',
    url: '/hotel/getHotelBasicInfo',
  });
};

// 房价日历-单日卖价-通过门店编码查询客源渠道列表V2
export const queryChannelsList = () => {
  return http({
    method: 'GET',
    url: '/channels/v2',
  });
};

// 房价日历-单日卖价-今日卖价看板
export const queryPriceDashboard = (params) => {
  return http({
    method: 'POST',
    url: `/price-dashboard/query`,
    data: params,
  });
};

// 房价日历-房价日历看板-月度
export const queryPriceMonthCalender = (params) => {
  return http({
    method: 'GET',
    url: '/kanban/pricing/month/calender',
    params,
  });
};

// 门店推送失败日志
export const getPromotionFailLog = (data) => {
  return http({
    method: 'POST',
    url: '/ota/promotion/list/failed',
    data,
  });
};

// 重新推送活动
export const retryPromotionItem = (params) => {
  return http({
    method: 'GET',
    url: '/ota/promotion/rePush',
    params,
  });
};

// 变更收款方式
export const updateSettleType = (data) => {
  return http({
    method: 'POST',
    url: '/dy-hotel-static-info/update/settle-type',
    data,
  });
};

// 删除价差档
export const getDeletePriceDiffConfig = (params) => {
  return http({
    method: 'DELETE',
    url: '/price-diff-config',
    params,
  });
};
// 价差档日志
export const getPriceDiffConfigLog = (params) => {
  return http({
    method: 'GET',
    url: '/price-diff-config/log',
    params,
  });
};

// 获取价差档列表
export const getPriceDiffConfigList = () => {
  return http({
    method: 'GET',
    url: '/price-diff-config/list/common-code',
  });
};

// 获取价差详情
export const getPriceDiffConfigDetail = (params) => {
  return http({
    method: 'GET',
    url: '/price-diff-config',
    params,
  });
};

// 价差档渠道列表
export const getPriceDiffChannelList = () => {
  return http({
    method: 'GET',
    url: 'price-diff-config/channels',
  });
};

// 创建、修改价差档配置
export const updatePriceDiffConfig = (data) => {
  return http({
    method: 'POST',
    url: '/price-diff-config',
    data,
  });
};
// 创建ota产品
export const createRpProduct = (data) => {
  return http({
    method: 'POST',
    url: '/ota/product/create/rp',
    data,
  });
};

// 查询同步记录列表
export const querySyncLogList = (data) => {
  return http({
    method: 'POST',
    url: '/channel-push-logs/page',
    data,
    headers: { urlPrefix: 'hotel-misc-svc' },
  });
};

// 同步记录-推送内容
export const queryPushContent = (id) => {
  return http({
    method: 'GET',
    url: `/channel-push-logs/${id}/request`,
    headers: { urlPrefix: 'hotel-misc-svc' },
  });
};

// 同步记录-返回内容
export const queryReturnContent = (id) => {
  return http({
    method: 'GET',
    url: `/channel-push-logs/${id}/response`,
    headers: { urlPrefix: 'hotel-misc-svc' },
  });
};

// 更新ota产品
export const updateRpProduct = (data) => {
  return http({
    method: 'POST',
    url: '/ota/product/update/rp',
    data,
  });
};

// 集团-折扣率提醒列表
export const fetchDiscountRateNoticeList = (data?: any) => {
  return http({
    method: 'POST',
    url: `/discount-rate-notice-config/list`,
    data,
  });
};

// 直连房量排查
export const fetchAllEmployee = (params?) => {
  return http({
    url: `/employee/simple/query`,
    params,
  });
};

// 批量编辑折扣率提醒配置（兼容单店）
export const fetchDiscountRateAlertSave = (data?: any) => {
  return http({
    method: 'PUT',
    url: `/discount-rate-notice-config/batch-update`,
    data,
  });
};

// 折扣率提醒日志
export const fetchDiscountRateAlertLogPgae = (data?: any) => {
  return http({
    method: 'POST',
    url: `/discount-rate-notice-config/log`,
    data,
  });
};

// 新店-折扣率提醒配置
export const fetchDiscountRateAlertUpdate = (data?: any) => {
  return http({
    method: 'PUT',
    url: `/discount-rate-notice-config/default-update`,
    data,
  });
};

// 新店-折扣率提醒配置-查询
export const fetchDiscountRateAlerDetail = (params?) => {
  return http({
    url: `/discount-rate-notice-config/default-detail`,
    params,
  });
};

// 按门店刷新房量限制秒数
export const getDiffRefreshSeconds = (params: { commonCode: string }) => {
  return http({
    url: `/room-quantity/getDiffRefreshSeconds`,
    params,
  });
};

// 按门店刷新房量限制秒数
export const refreshByCommonCode = (data: { commonCode: string }) => {
  return http({
    method: 'POST',
    url: `/room-quantity/refreshByCommonCode`,
    data,
  });
};
